export enum AuthorityEnum {
  MASTER = 'DIRETOR',
  ADMINISTRADOR = 'ADMINISTRADOR'
}
